import { IMerchant } from "@/i/merchant.ts";
import { ICoupon } from "@/i/coupon";
import { IHomeState, IBannerCoupons } from "@/i/home.state.ts";
import {
  factoryCoupon,
  factoryMerchantWithoutCoupon,
  parseType
} from "./coupons";
import { merchantFactory } from "./merchant";

export const bannerCouponsFactory = (_merchants): IBannerCoupons[] => {
  return _merchants.map(c => {
    if (c.coupons[0]) {
      return Object.assign(factoryCoupon(c.coupons[0], c.merchant), {
        leftImg: c.banner_images.left,
        rightImg: c.banner_images.right
      });
    } else {
      return Object.assign(factoryMerchantWithoutCoupon(c.merchant), {
        leftImg: c.banner_images.left,
        rightImg: c.banner_images.right
      });
    }
  });
};

export const topCouponsFactory = (_c): ICoupon[] => {
  let coupons = [];
  ["best", "free", "newest"].forEach(type => {
    if(_c[type][0]){
      coupons.push(
        Object.assign(factoryCoupon(_c[type][0], { logo: "", name: "" }), {
          type: parseType(type)
        })
      );
    }
  });
  return coupons;
};

export const topMerchantsFactory = (_merchants): IMerchant[] => {
  return _merchants.map(m => merchantFactory(m));
};

export const isLoadingFactory = () => {}

export const mainFactory = ({
  banner_merchants,
  top_coupons,
  top_merchants,
  is_loading
}): IHomeState => {
  return {
    bannerCoupons: bannerCouponsFactory(banner_merchants),
    topCoupons: topCouponsFactory(top_coupons),
    topMerchants: topMerchantsFactory(top_merchants),
    isLoading: is_loading
  };
};
